// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"wa_a bho_b bho_we"};